import React, {useEffect, useState} from "react";
import {Option} from "../../models/BojaModel";
import {getOdjel} from "../../api";
import SearchableSelect from "../SearchableSelect/SearchableSelect";
import {getAkitvniProjektiDropdown} from "../../api/predrezervacijaMaterijala";

interface DropdownProps {
    value?: string | number
    initialValue?: string | number
    onChange?: (name: string, value: any) => void
    errors?: string | undefined
    touched?: boolean
    selectName?: string
}

const mapDropdown = (data) => {
    return data.map((item) => ({label: item.NazivProjekta, value: item.Id.toString()}))
}

const AktivniProjektiDropdown: React.FC<DropdownProps> = ({
                                                             value,
                                                             initialValue,
                                                             onChange,
                                                             errors,
                                                             touched,
                                                             selectName,
                                                         }) => {
    const [odjelDropdown, setOdjelDropdown] = useState<Array<Option>>([])
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const [internalValue, setInternalValue] = useState<string | number | null>(initialValue ?? null)

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await getAkitvniProjektiDropdown()
                setOdjelDropdown(mapDropdown(response.data))
            } catch (error) {
                console.error('Error fetching sektor dropdown data:', error)
            }
        }
        fetchData()
    }, [])

    const finalValue = typeof value !== 'undefined' ? value : internalValue

    return (
        <SearchableSelect
            options={odjelDropdown}
            value={finalValue?.toString() ?? ''}
            onChange={onChange!}
            name={selectName ?? 'Predrezervacije'}
            errors={errors}
            placeholder='Odaberi projekat...'
            touched={touched}
        />
    )
}
export default AktivniProjektiDropdown;
